(function() {
  define('bazemont/booking/page',['angular', 'angularSanitize'], function() {
    'use strict';
    return angular.module('bazemontBookingPage', ['ngSanitize']).component('bazemontBookingPage', {
      templateUrl: '/assets/javascripts/bazemont/booking/page.html',
      controller: [
        '$http', '$timeout', function($http, $timeout) {
          var vm;
          vm = this;
          vm.bookingRequest = {
            isLocal: true
          };
          vm.changeBookingItem = function(bookingItem) {
            vm.bookingRequest.bookingDate = void 0;
            return vm.loadSelectableDates(bookingItem, true);
          };
          vm.loadSelectableDates = function(bookingItem, cache) {
            vm.showDatepicker = false;
            if (bookingItem) {
              return $http.get('/api/booking/dates', {
                cache: cache,
                params: {
                  itemId: bookingItem.id
                }
              }).then(function(response) {
                return $timeout(function() {
                  vm.selectableDates = response.data;
                  return vm.showDatepicker = true;
                });
              });
            }
          };
        }
      ]
    });
  });

}).call(this);

//# sourceMappingURL=page.js.map
;
